export class Auth0User {
  password: string;

  constructor(public email: string) {}

  static parse(data: Partial<Auth0User>): Auth0User {
    if (!data) throw new Error('Cannot parse Auth0User');

    return new Auth0User(data.email);
  }
}
